import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import NorthStar from "../components/NorthStar";
import Button from "../components/Button";
import { Field } from "../components/Field";
import client, { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await client.post("/auth/login", { email, password });
      localStorage.setItem("nstr_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12 justify-center">
          <NorthStar className="w-5 h-5 text-warm" />
          <span className="font-sans text-sm tracking-[0.28em] uppercase text-warm">NSTR Talent</span>
        </div>
        <div className="border border-charcoal p-10">
          <div className="label mb-3">Admin</div>
          <h1 className="font-serif text-4xl text-warm mb-10">Sign in</h1>
          <form onSubmit={onSubmit} className="space-y-8">
            <Field label="Email" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required testId="admin-email" />
            <Field label="Password" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required testId="admin-password" />
            <Button type="submit" variant="primary" className="w-full" disabled={loading} data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
        </div>
        <a href="/" className="label link-underline !text-silver/60 hover:!text-warm block text-center mt-8">
          Back to site
        </a>
      </div>
    </div>
  );
}
